import { DateTime } from "luxon";
import Day from "./Day";

function topHourOffset(shiftsByDay, start_date, num_days) {
  let topHourOffset = Infinity;
  const startDate =
    start_date instanceof DateTime ? start_date : DateTime.fromISO(start_date);

  for (let i = 0; i < num_days; i++) {
    const dayOfYear = startDate.plus({ days: i }).ordinal;
    if (shiftsByDay[dayOfYear]) {
      topHourOffset = Math.min(
        topHourOffset,
        ...shiftsByDay[dayOfYear].map((shift) => {
          const shiftTime =
            shift.start_time instanceof DateTime
              ? shift.start_time
              : DateTime.fromISO(shift.start_time);
          return shiftTime.hour;
        })
      );
    }
  }
  return topHourOffset;
}

function groupShiftsByDay(shifts) {
  return shifts.reduce((result, current) => {
    const shiftTime =
      current.start_time instanceof DateTime
        ? current.start_time
        : DateTime.fromISO(current.start_time);
    const dayOfYear = shiftTime.ordinal;
    if (!result[dayOfYear]) result[dayOfYear] = [];
    result[dayOfYear].push(current);
    return result;
  }, {});
}

const DaysTable = (props) => {
  const {
    shifts,
    event,
    start_date,
    num_days,
    memberTypeProperties,
    readOnly,
    canSkipValidation,
  } = props;
  const shiftsByDay = groupShiftsByDay(shifts);
  const topHour = topHourOffset(shiftsByDay, start_date, num_days);

  const startDate =
    start_date instanceof DateTime ? start_date : DateTime.fromISO(start_date);

  const dayNodes = [];
  for (let i = 0; i < num_days; i++) {
    const current_day = startDate.plus({ days: i });
    const dayOfYear = current_day.ordinal;
    const dayShifts = shiftsByDay[dayOfYear];
    dayNodes.push(
      <Day
        key={i}
        event={event}
        date={current_day}
        shifts={dayShifts}
        memberTypeProperties={memberTypeProperties}
        readOnly={readOnly}
        canSkipValidation={canSkipValidation}
        topHourOffset={topHour}
      />
    );
  }

  return <div className="days_table clearfix">{dayNodes}</div>;
};

export default DaysTable;
